"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function DropzoneFileIcon(_ref) {
  var filename = _ref.filename,
    status = _ref.status;
  var theme = (0, _material.useTheme)();
  var extension = (0, _react.useMemo)(function () {
    var lastIndex = filename.lastIndexOf('.');
    return filename.substring(lastIndex + 1);
  }, [filename]);
  var color = (0, _react.useMemo)(function () {
    switch (status) {
      case 'processing':
        return theme.palette.grey[400];
      case 'completed':
        return theme.palette.primary.main;
      case 'rejected':
        return theme.palette.warning.main;
      default:
        return theme.palette.error.main;
    }
  }, [status, theme]);
  return /*#__PURE__*/_react["default"].createElement(_material.Avatar, {
    sx: {
      bgcolor: color
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "caption",
    fontWeight: "bold",
    textTransform: "uppercase"
  }, extension !== null && extension !== void 0 ? extension : '???'));
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(DropzoneFileIcon);